import ResumeTimelineRecordLayout from './ResumeTimelineRecordLayout';
import CreateResumeForm from 'domain/recruiting/candidate/Timeline/resume/form/CreateResumeForm';
import UpdateResumeForm from 'domain/recruiting/candidate/Timeline/resume/form/UpdateResumeForm';
import { CREATE_CANDIDATE_RESUME } from 'domain/recruiting/candidate/Timeline/resume/resumeService';

const useCandidateResumeItem = () => ({
  AddForm: CreateResumeForm,
  UpdateForm: UpdateResumeForm,
  isApplicable: (item: any) => !!item.resume || item.type === 'RESUME_ADDED',
  source: 'resume',
  urlPostfix: 'resumes',
  RecordLayout: ResumeTimelineRecordLayout,
  name: 'Resume',
  permissionToCheck: CREATE_CANDIDATE_RESUME,
});

export default useCandidateResumeItem;
